import type { FC } from 'react'
import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import { TextFieldInput, TextFieldInputProps } from './TextFieldInput.js'

export const LastNameInput: FC<TextFieldInputProps> = ({ name, ...props }) => {
  const { t } = useTranslation()

  return <TextFieldInput {...props} name={name} type="text" label={t('inputs.lastNameInput.lastNameLabel')} />
}

export const createLastNameValidationSchema = (
  t: TFunction
): Yup.StringSchema<string, Yup.AnyObject, string, Yup.ToggleDefault<'', string>> =>
  Yup.string().required(t('inputs.lastNameInput.lastNameIsRequiredErrorMessage')).default('')
